<div class="coupon-card-vip-root" *transloco="let t" (click)="openCouponDetails(business!.id)">
  <div class="content">
    <div class="header">
      <div class="business-data">
        <app-rounded-image xxsmall [src]="businessImgBase64"></app-rounded-image>
        <span class="business-name"
              [matTooltip]="businessName.length > 50 ? businessName : ''"
              matTooltipClass="name-tooltip">{{ businessName }}
        </span>
        <span class="business-vip"> - {{ vipLevel }}</span>
      </div>
      <app-icon-click flat
                      id="business-info-click"
                      *ngIf="_showButtonInfo"
                      (click)="toggleInfo($event)">info_outline</app-icon-click>
    </div>
    <div class="popup-preamble">
      <app-business-info-popup [ngClass]="{ 'visible' : showInfo }"
                               [activePoints]="businessPointsInfo?.totalPoints"
                               [pointsAddedThisMonth]="businessPointsInfo?.addedOnThisMonth"
                               [pointsExpiringThisMonth]="businessPointsInfo?.expiringOnThisMonth"
                               [nextPointsExpiring]="businessPointsInfo?.nextPointsExpiring"
                               [nextPointsExpiringDate]="businessPointsInfo?.nextPointsExpiringDate"
                               [pointsRedeemedThisMonth]="businessPointsInfo?.redeemedOnThisMonth"
                               [pointsExpiredLastYear]="businessPointsInfo?.expiredLastYear"
                               [pointsExpiringThisYear]="businessPointsInfo?.expiringOnThisYear"
                               [pointsExpiringNextYear]="businessPointsInfo?.expiringOnNextYear"
                               [familyName]="familyName"
                               [registersOnVIPWindow]="businessPointsInfo?.registersOnVIPWindow"
                               [state]="businessPointsInfo?.state"
                               [country]="'fi fi-'+businessPointsInfo?.country?.initials.toLowerCase()"
                               (closeClick)="closeInfo($event)">
      </app-business-info-popup>
    </div>
    <app-horizontal-separator></app-horizontal-separator>
    <div class="center">
      <div class="rewards-data">
        <div class="grid-item">
          <span class="grid-title" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ t('ink-discount-models-customer') }}</span>
          <div class="model-value" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ uniqueModel | transloco }}</div>
        </div>
        <div class="grid-item">
          <span class="grid-title" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ t('reseller') }}</span>
          <div class="value" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ resellerName }}</div>
        </div>
        <div class="grid-item">
          <span class="grid-title" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ t('discount-value-customer') }}</span>
          <div class="value" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ discountValue }}%</div>
        </div>
        <div class="grid-item">
          <span class="grid-title" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ t('issued-date') }}</span>
          <div class="value" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ startingDate | date : 'd MMM y' : '' : language }}</div>
        </div>
      </div>
    </div>
    <span class="title-code" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ t('discount-code') }}</span>
    <span class="code" [ngClass]="{ 'text-disabled' : timelineDisabled }">{{ couponCode }}</span>
    <span class="country" *ngIf="countryName" [ngClass]="{ 'text-disabled' : timelineDisabled }">
      {{ t('coupon-valid-country', { countryName: countryName }) }}
    </span>
    <span class="special-promo" [ngClass]="{ 'text-disabled' : timelineDisabled }">
      {{ configSeriesDisclaimer }}
    </span>
    <app-horizontal-separator></app-horizontal-separator>
    <div class="footer">
      <app-chip *ngIf="!timelineDisabled" small id="expiration-info" defaultCursor small filled [lightgray]="!active" [green]="active">
        {{ statusCheck | transloco }}
        {{ expirationDate | date : 'd MMM y' : '' : language }}
      </app-chip>
      <div *ngIf="timelineDisabled">
        This business coupon timeline is disabled
      </div>
    </div>
  </div>
</div>

